// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentationItem-module__font-s-10___frX0U {
  font-size: 10px !important;
}

.DocumentationItem-module__font-s-12___wmY1K {
  font-size: 12px !important;
}

.DocumentationItem-module__font-s-13___MDb09 {
  font-size: 13px !important;
}

.DocumentationItem-module__font-s-14___lxOZz {
  font-size: 14px !important;
}

.DocumentationItem-module__font-s-15___JZKCL {
  font-size: 15px !important;
}

.DocumentationItem-module__font-s-16___c4zsA {
  font-size: 16px !important;
}

.DocumentationItem-module__font-s-18___MwYCL {
  font-size: 18px !important;
}

.DocumentationItem-module__font-s-20___J6BE_ {
  font-size: 20px !important;
}

.DocumentationItem-module__font-s-22___LROjO {
  font-size: 22px !important;
}

.DocumentationItem-module__font-s-28___zjwuM {
  font-size: 28px !important;
}

.DocumentationItem-module__font-w-400___J5J7z {
  font-weight: 400 !important;
}

.DocumentationItem-module__font-w-500___dJNcw {
  font-weight: 500 !important;
}

.DocumentationItem-module__font-w-600___b59f4 {
  font-weight: 600 !important;
}

.DocumentationItem-module__font-w-700___MBeFR {
  font-weight: 700 !important;
}

.DocumentationItem-module__p-5___sqsy0 {
  padding: 5px !important;
}

.DocumentationItem-module__p-12___KjJld {
  padding: 12px !important;
}

.DocumentationItem-module__p-16___Lzq5C {
  padding: 16px !important;
}

.DocumentationItem-module__p-30___Hy70L {
  padding: 30px !important;
}

.DocumentationItem-module__p-b-0___Pw06J {
  padding-bottom: 0 !important;
}

.DocumentationItem-module__p-b-5___A5qda {
  padding-bottom: 5px !important;
}

.DocumentationItem-module__p-b-10___N2kRh {
  padding-bottom: 10px !important;
}

.DocumentationItem-module__p-b-12___XtlkL {
  padding-bottom: 12px !important;
}

.DocumentationItem-module__p-b-16___Tvahr {
  padding-bottom: 16px !important;
}

.DocumentationItem-module__p-b-18___kop9o {
  padding-bottom: 18px !important;
}

.DocumentationItem-module__p-b-20___MDBxZ {
  padding-bottom: 20px !important;
}

.DocumentationItem-module__p-b-25___eUPNB {
  padding-bottom: 25px !important;
}

.DocumentationItem-module__p-b-30___OQbM3 {
  padding-bottom: 30px !important;
}

.DocumentationItem-module__p-b-50___KD24G {
  padding-bottom: 50px !important;
}

.DocumentationItem-module__p-t-0___qoRVc {
  padding-top: 0 !important;
}

.DocumentationItem-module__p-t-12___veYr_ {
  padding-top: 12px !important;
}

.DocumentationItem-module__p-t-16___ay4QH {
  padding-top: 16px !important;
}

.DocumentationItem-module__p-t-18___nHyE5 {
  padding-top: 18px !important;
}

.DocumentationItem-module__p-t-20___gkkIi {
  padding-top: 20px !important;
}

.DocumentationItem-module__p-t-30___IM7Ry {
  padding-top: 30px !important;
}

.DocumentationItem-module__p-t-40___OsEL6 {
  padding-top: 40px !important;
}

.DocumentationItem-module__p-t-50___Bv6nu {
  padding-top: 50px !important;
}

.DocumentationItem-module__p-l-20___aTKSt {
  padding-left: 20px !important;
}

.DocumentationItem-module__p-l-30___epS6r {
  padding-left: 30px !important;
}

.DocumentationItem-module__p-l-40___ZaNIt {
  padding-left: 40px !important;
}

.DocumentationItem-module__p-r-16___AWAcY {
  padding-right: 16px !important;
}

.DocumentationItem-module__p-r-20___IG1Kq {
  padding-right: 20px !important;
}

.DocumentationItem-module__p-r-30___bIiQY {
  padding-right: 30px !important;
}

.DocumentationItem-module__p-r-50___U5uYG {
  padding-right: 50px !important;
}

.DocumentationItem-module__p-r-60___DvszS {
  padding-right: 60px !important;
}

.DocumentationItem-module__m-b-1___d1isz {
  margin-bottom: 1px !important;
}

.DocumentationItem-module__m-b-2___ylLKC {
  margin-bottom: 2px !important;
}

.DocumentationItem-module__m-b-6___UZ8Pc {
  margin-bottom: 6px !important;
}

.DocumentationItem-module__m-b-8___khzSu {
  margin-bottom: 8px !important;
}

.DocumentationItem-module__m-b-10___mKRA_ {
  margin-bottom: 10px !important;
}

.DocumentationItem-module__m-b-14___qVYMD {
  margin-bottom: 14px !important;
}

.DocumentationItem-module__m-b-16___l0eve {
  margin-bottom: 16px !important;
}

.DocumentationItem-module__m-b-20___wvVfB {
  margin-bottom: 20px !important;
}

.DocumentationItem-module__m-b-22___nE9B1 {
  margin-bottom: 22px !important;
}

.DocumentationItem-module__m-b-24___HdLFq {
  margin-bottom: 24px !important;
}

.DocumentationItem-module__m-b-30___YVus1 {
  margin-bottom: 30px !important;
}

.DocumentationItem-module__m-b-32___h6T5Z {
  margin-bottom: 32px !important;
}

.DocumentationItem-module__m-b-40___ucmFz {
  margin-bottom: 40px !important;
}

.DocumentationItem-module__m-t-2___PPUAX {
  margin-top: 2px !important;
}

.DocumentationItem-module__m-t-3___V1w3c {
  margin-top: 3px !important;
}

.DocumentationItem-module__m-t-4___rFwmg {
  margin-top: 4px !important;
}

.DocumentationItem-module__m-t-5___YYz5f {
  margin-top: 5px !important;
}

.DocumentationItem-module__m-t-8___Gk5YX {
  margin-top: 8px !important;
}

.DocumentationItem-module__m-t-10___VSA7H {
  margin-top: 10px !important;
}

.DocumentationItem-module__m-t-15___yV_SS {
  margin-top: 15px !important;
}

.DocumentationItem-module__m-t-16___tNNHH {
  margin-top: 16px !important;
}

.DocumentationItem-module__m-t-20___a9hCj {
  margin-top: 20px !important;
}

.DocumentationItem-module__m-t-22___TFh7Z {
  margin-top: 22px !important;
}

.DocumentationItem-module__m-t-30___fyDEM {
  margin-top: 30px !important;
}

.DocumentationItem-module__m-t-32___EJGQt {
  margin-top: 32px !important;
}

.DocumentationItem-module__m-l-auto___BUlUF {
  margin-left: auto !important;
}

.DocumentationItem-module__m-l-4___HwF7q {
  margin-left: 4px !important;
}

.DocumentationItem-module__m-l-5___mNTsw {
  margin-left: 5px !important;
}

.DocumentationItem-module__m-l-6___Bm7Kz {
  margin-left: 6px !important;
}

.DocumentationItem-module__m-l-8____7UoJ {
  margin-left: 8px !important;
}

.DocumentationItem-module__m-l-10___fNlDV {
  margin-left: 10px !important;
}

.DocumentationItem-module__m-l-16___gI_Ww {
  margin-left: 16px !important;
}

.DocumentationItem-module__m-l-20___ltdMe {
  margin-left: 20px !important;
}

.DocumentationItem-module__m-l-24___XZuKR {
  margin-left: 24px !important;
}

.DocumentationItem-module__m-l-30___KgKJN {
  margin-left: 30px !important;
}

.DocumentationItem-module__m-l-35___Wvili {
  margin-left: 35px !important;
}

.DocumentationItem-module__m-l-40___oPyGp {
  margin-left: 40px !important;
}

.DocumentationItem-module__m-r-8____IdsN {
  margin-right: 8px !important;
}

.DocumentationItem-module__m-r-10___KHr_F {
  margin-right: 10px !important;
}

.DocumentationItem-module__m-r-16___U4A3X {
  margin-right: 16px !important;
}

.DocumentationItem-module__m-r-20___PndzD {
  margin-right: 20px !important;
}

.DocumentationItem-module__m-r-24___pv_ij {
  margin-right: 24px !important;
}

.DocumentationItem-module__m-r-30___ZjoII {
  margin-right: 30px !important;
}

.DocumentationItem-module__m-r-40___gYKzD {
  margin-right: 40px !important;
}

.DocumentationItem-module__border-r-3___v3qMe {
  border-radius: 3px !important;
}

.DocumentationItem-module__border-r-4___KSgpu {
  border-radius: 4px !important;
}

.DocumentationItem-module__border-r-6___iKHVv {
  border-radius: 6px !important;
}

.DocumentationItem-module__border-r-10___hpUTS {
  border-radius: 10px !important;
}

.DocumentationItem-module__border-r-12___Au1_E {
  border-radius: 12px !important;
}

.DocumentationItem-module__border-r-16___G2gzK {
  border-radius: 16px !important;
}

.DocumentationItem-module__border-r-50___WOZbx {
  border-radius: 50% !important;
}

.DocumentationItem-module__primary-border___Dm7mG {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationItem-module__primary-border-b___KF4iU {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationItem-module__primary-border-t___oIV4J {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationItem-module__primary-border-l___mt2S2 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationItem-module__primary-border-r___a07h3 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationItem-module__secondary-border___pYHmg {
  border: 1px solid #637768;
}

.DocumentationItem-module__secondary-border-b___bcXNI {
  border-bottom: 1px solid #637768;
}

.DocumentationItem-module__secondary-border-t___Uhwwo {
  border-top: 1px solid #637768;
}

.DocumentationItem-module__secondary-border-l___kSXe3 {
  border-left: 1px solid #637768;
}

.DocumentationItem-module__secondary-border-r___PFAsE {
  border-right: 1px solid #637768;
}

.DocumentationItem-module__gap-0____YLOE {
  gap: 0 !important;
}

.DocumentationItem-module__gap-2___u2XAy {
  gap: 2px !important;
}

.DocumentationItem-module__gap-4___ZKAAz {
  gap: 4px !important;
}

.DocumentationItem-module__gap-5___utauX {
  gap: 5px !important;
}

.DocumentationItem-module__gap-6___ndGDA {
  gap: 6px !important;
}

.DocumentationItem-module__gap-8___Kwk_g {
  gap: 8px !important;
}

.DocumentationItem-module__gap-10___ddp0_ {
  gap: 10px !important;
}

.DocumentationItem-module__gap-12___ALKsz {
  gap: 12px !important;
}

.DocumentationItem-module__gap-14___cCgfG {
  gap: 14px !important;
}

.DocumentationItem-module__gap-16___aCTj1 {
  gap: 16px !important;
}

.DocumentationItem-module__gap-18___Czizj {
  gap: 18px !important;
}

.DocumentationItem-module__gap-20____sVkZ {
  gap: 20px !important;
}

.DocumentationItem-module__gap-24___OnZVS {
  gap: 24px !important;
}

.DocumentationItem-module__gap-26___eOpN1 {
  gap: 26px !important;
}

.DocumentationItem-module__gap-30___q8ow3 {
  gap: 30px !important;
}

.DocumentationItem-module__gap-32___UDv8j {
  gap: 32px !important;
}

.DocumentationItem-module__gap-40___EffLm {
  gap: 40px !important;
}

.DocumentationItem-module__gap-50___FNwJI {
  gap: 50px !important;
}

.DocumentationItem-module__flex-1___jnSx9 {
  flex: 1;
}

.DocumentationItem-module__flex-none___uJTdc {
  flex: none !important;
}

.DocumentationItem-module__flex-column___FHZ3L {
  display: flex;
  flex-direction: column !important;
}

.DocumentationItem-module__flex-row___pGDSZ {
  display: flex;
  flex-direction: row !important;
}

.DocumentationItem-module__vertically-centered___jlCBH {
  display: flex;
  align-items: center !important;
}

.DocumentationItem-module__horizontally-centered___QJZ1P {
  display: flex;
  justify-content: center !important;
}

.DocumentationItem-module__horizontally-end___RtVz1 {
  display: flex;
  justify-content: end !important;
}

.DocumentationItem-module__vertically-start___dB7CP {
  display: flex;
  align-items: start !important;
}

.DocumentationItem-module__space-between___xwrvj {
  display: flex;
  justify-content: space-between !important;
}

.DocumentationItem-module__flex-wrap___JFJM0 {
  flex-wrap: wrap !important;
}

.DocumentationItem-module__height-100___sq_BK {
  height: 100%;
}

.DocumentationItem-module__width-50___Llzbk {
  width: 50% !important;
}

.DocumentationItem-module__width-100___jGCRD {
  width: 100%;
}

.DocumentationItem-module__cursor-pointer___B_Nsl {
  cursor: pointer;
}

.DocumentationItem-module__cursor-not-allowed___GQhUf {
  cursor: not-allowed !important;
}

.DocumentationItem-module__absolute-centered___np4YI {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DocumentationItem-module__absolute___HXUfL {
  position: absolute;
}

.DocumentationItem-module__relative___acYJ1 {
  position: relative;
}

.DocumentationItem-module__fixed___k9ixs {
  position: fixed;
}

.DocumentationItem-module__visible___VLn6F {
  opacity: 1;
}

.DocumentationItem-module__invisible___Fm0GV {
  opacity: 0;
}

.DocumentationItem-module__col-90___nYlxn {
  width: 90% !important;
}

.DocumentationItem-module__col-auto___L7aIa {
  width: auto !important;
}

.DocumentationItem-module__medical-tabs___XRToT {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DocumentationItem-module__medical-table-new___R9uGa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationItem-module__medical-table-new___R9uGa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationItem-module__medical-table-new___R9uGa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationItem-module__medical-table-new___R9uGa::-webkit-scrollbar-track {
  display: none;
}
.DocumentationItem-module__medical-table-new___R9uGa.DocumentationItem-module__no-pagination___SJ8jO {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationItem-module__medical-table-new___R9uGa.DocumentationItem-module__no-pagination___SJ8jO:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationItem-module__medical-table-new___R9uGa.DocumentationItem-module__no-pagination___SJ8jO::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationItem-module__medical-table-new___R9uGa.DocumentationItem-module__no-pagination___SJ8jO::-webkit-scrollbar-track {
  display: none;
}

.DocumentationItem-module__medical-table-empty___CnW0u {
  padding: 14px 40px !important;
}

.DocumentationItem-module__icon-btn___ASI8V {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DocumentationItem-module__search-icon___zPVNp {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DocumentationItem-module__disable-select___Is1dH {
  user-select: none;
}

.DocumentationItem-module__break-word___Yo6JY {
  word-break: break-word;
}

.DocumentationItem-module__popup-clear-btn___qFvvS {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DocumentationItem-module__scroll-m-b-20___ej8Xe {
  scroll-margin-bottom: 20px;
}

.DocumentationItem-module__container___UyE8o {
  padding: 12px 16px;
}
.DocumentationItem-module__container___UyE8o.DocumentationItem-module__selected___F2BDN {
  background-color: #f1f3e7;
}
.DocumentationItem-module__container___UyE8o .DocumentationItem-module__icon___rDBdj {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  align-self: flex-start;
}
.DocumentationItem-module__container___UyE8o .DocumentationItem-module__content___V08xT {
  flex: 1;
}
.DocumentationItem-module__container___UyE8o .DocumentationItem-module__content___V08xT .DocumentationItem-module__name___Q6F0r {
  color: #a79988;
}
.DocumentationItem-module__container___UyE8o .DocumentationItem-module__content___V08xT .DocumentationItem-module__type___NAi5N {
  color: #375844;
}
.DocumentationItem-module__container___UyE8o .DocumentationItem-module__content___V08xT .DocumentationItem-module__reason___IBOKM {
  color: #859989;
}
.DocumentationItem-module__container___UyE8o .DocumentationItem-module__content___V08xT .DocumentationItem-module__date___fLUk7 {
  color: #637768;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DocumentationFragment/items/DocumentationItem/DocumentationItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AA6pBJ;AA1pBE;EACE,OAAA;AA4pBJ;AA1pBI;EACE,cAAA;AA4pBN;AAzpBI;EACE,cAAA;AA2pBN;AAxpBI;EACE,cAAA;AA0pBN;AAvpBI;EACE,cAAA;AAypBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  padding: 12px 16px;\n\n  &.selected {\n    background-color: get-color(greenNew, lighter);\n  }\n\n  .icon {\n    width: 34px;\n    height: 34px;\n    margin-right: 10px;\n    align-self: flex-start;\n  }\n\n  .content {\n    flex: 1;\n\n    .name {\n      color: get-color(orangeNew, medium-dark);\n    }\n\n    .type {\n      color: get-color(greenNew, dark);\n    }\n\n    .reason {\n      color: get-color(greenNew, medium);\n    }\n\n    .date {\n      color: get-color(greenNew, medium-dark);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DocumentationItem-module__font-s-10___frX0U`,
	"fontS12": `DocumentationItem-module__font-s-12___wmY1K`,
	"fontS13": `DocumentationItem-module__font-s-13___MDb09`,
	"fontS14": `DocumentationItem-module__font-s-14___lxOZz`,
	"fontS15": `DocumentationItem-module__font-s-15___JZKCL`,
	"fontS16": `DocumentationItem-module__font-s-16___c4zsA`,
	"fontS18": `DocumentationItem-module__font-s-18___MwYCL`,
	"fontS20": `DocumentationItem-module__font-s-20___J6BE_`,
	"fontS22": `DocumentationItem-module__font-s-22___LROjO`,
	"fontS28": `DocumentationItem-module__font-s-28___zjwuM`,
	"fontW400": `DocumentationItem-module__font-w-400___J5J7z`,
	"fontW500": `DocumentationItem-module__font-w-500___dJNcw`,
	"fontW600": `DocumentationItem-module__font-w-600___b59f4`,
	"fontW700": `DocumentationItem-module__font-w-700___MBeFR`,
	"p5": `DocumentationItem-module__p-5___sqsy0`,
	"p12": `DocumentationItem-module__p-12___KjJld`,
	"p16": `DocumentationItem-module__p-16___Lzq5C`,
	"p30": `DocumentationItem-module__p-30___Hy70L`,
	"pB0": `DocumentationItem-module__p-b-0___Pw06J`,
	"pB5": `DocumentationItem-module__p-b-5___A5qda`,
	"pB10": `DocumentationItem-module__p-b-10___N2kRh`,
	"pB12": `DocumentationItem-module__p-b-12___XtlkL`,
	"pB16": `DocumentationItem-module__p-b-16___Tvahr`,
	"pB18": `DocumentationItem-module__p-b-18___kop9o`,
	"pB20": `DocumentationItem-module__p-b-20___MDBxZ`,
	"pB25": `DocumentationItem-module__p-b-25___eUPNB`,
	"pB30": `DocumentationItem-module__p-b-30___OQbM3`,
	"pB50": `DocumentationItem-module__p-b-50___KD24G`,
	"pT0": `DocumentationItem-module__p-t-0___qoRVc`,
	"pT12": `DocumentationItem-module__p-t-12___veYr_`,
	"pT16": `DocumentationItem-module__p-t-16___ay4QH`,
	"pT18": `DocumentationItem-module__p-t-18___nHyE5`,
	"pT20": `DocumentationItem-module__p-t-20___gkkIi`,
	"pT30": `DocumentationItem-module__p-t-30___IM7Ry`,
	"pT40": `DocumentationItem-module__p-t-40___OsEL6`,
	"pT50": `DocumentationItem-module__p-t-50___Bv6nu`,
	"pL20": `DocumentationItem-module__p-l-20___aTKSt`,
	"pL30": `DocumentationItem-module__p-l-30___epS6r`,
	"pL40": `DocumentationItem-module__p-l-40___ZaNIt`,
	"pR16": `DocumentationItem-module__p-r-16___AWAcY`,
	"pR20": `DocumentationItem-module__p-r-20___IG1Kq`,
	"pR30": `DocumentationItem-module__p-r-30___bIiQY`,
	"pR50": `DocumentationItem-module__p-r-50___U5uYG`,
	"pR60": `DocumentationItem-module__p-r-60___DvszS`,
	"mB1": `DocumentationItem-module__m-b-1___d1isz`,
	"mB2": `DocumentationItem-module__m-b-2___ylLKC`,
	"mB6": `DocumentationItem-module__m-b-6___UZ8Pc`,
	"mB8": `DocumentationItem-module__m-b-8___khzSu`,
	"mB10": `DocumentationItem-module__m-b-10___mKRA_`,
	"mB14": `DocumentationItem-module__m-b-14___qVYMD`,
	"mB16": `DocumentationItem-module__m-b-16___l0eve`,
	"mB20": `DocumentationItem-module__m-b-20___wvVfB`,
	"mB22": `DocumentationItem-module__m-b-22___nE9B1`,
	"mB24": `DocumentationItem-module__m-b-24___HdLFq`,
	"mB30": `DocumentationItem-module__m-b-30___YVus1`,
	"mB32": `DocumentationItem-module__m-b-32___h6T5Z`,
	"mB40": `DocumentationItem-module__m-b-40___ucmFz`,
	"mT2": `DocumentationItem-module__m-t-2___PPUAX`,
	"mT3": `DocumentationItem-module__m-t-3___V1w3c`,
	"mT4": `DocumentationItem-module__m-t-4___rFwmg`,
	"mT5": `DocumentationItem-module__m-t-5___YYz5f`,
	"mT8": `DocumentationItem-module__m-t-8___Gk5YX`,
	"mT10": `DocumentationItem-module__m-t-10___VSA7H`,
	"mT15": `DocumentationItem-module__m-t-15___yV_SS`,
	"mT16": `DocumentationItem-module__m-t-16___tNNHH`,
	"mT20": `DocumentationItem-module__m-t-20___a9hCj`,
	"mT22": `DocumentationItem-module__m-t-22___TFh7Z`,
	"mT30": `DocumentationItem-module__m-t-30___fyDEM`,
	"mT32": `DocumentationItem-module__m-t-32___EJGQt`,
	"mLAuto": `DocumentationItem-module__m-l-auto___BUlUF`,
	"mL4": `DocumentationItem-module__m-l-4___HwF7q`,
	"mL5": `DocumentationItem-module__m-l-5___mNTsw`,
	"mL6": `DocumentationItem-module__m-l-6___Bm7Kz`,
	"mL8": `DocumentationItem-module__m-l-8____7UoJ`,
	"mL10": `DocumentationItem-module__m-l-10___fNlDV`,
	"mL16": `DocumentationItem-module__m-l-16___gI_Ww`,
	"mL20": `DocumentationItem-module__m-l-20___ltdMe`,
	"mL24": `DocumentationItem-module__m-l-24___XZuKR`,
	"mL30": `DocumentationItem-module__m-l-30___KgKJN`,
	"mL35": `DocumentationItem-module__m-l-35___Wvili`,
	"mL40": `DocumentationItem-module__m-l-40___oPyGp`,
	"mR8": `DocumentationItem-module__m-r-8____IdsN`,
	"mR10": `DocumentationItem-module__m-r-10___KHr_F`,
	"mR16": `DocumentationItem-module__m-r-16___U4A3X`,
	"mR20": `DocumentationItem-module__m-r-20___PndzD`,
	"mR24": `DocumentationItem-module__m-r-24___pv_ij`,
	"mR30": `DocumentationItem-module__m-r-30___ZjoII`,
	"mR40": `DocumentationItem-module__m-r-40___gYKzD`,
	"borderR3": `DocumentationItem-module__border-r-3___v3qMe`,
	"borderR4": `DocumentationItem-module__border-r-4___KSgpu`,
	"borderR6": `DocumentationItem-module__border-r-6___iKHVv`,
	"borderR10": `DocumentationItem-module__border-r-10___hpUTS`,
	"borderR12": `DocumentationItem-module__border-r-12___Au1_E`,
	"borderR16": `DocumentationItem-module__border-r-16___G2gzK`,
	"borderR50": `DocumentationItem-module__border-r-50___WOZbx`,
	"primaryBorder": `DocumentationItem-module__primary-border___Dm7mG`,
	"primaryBorderB": `DocumentationItem-module__primary-border-b___KF4iU`,
	"primaryBorderT": `DocumentationItem-module__primary-border-t___oIV4J`,
	"primaryBorderL": `DocumentationItem-module__primary-border-l___mt2S2`,
	"primaryBorderR": `DocumentationItem-module__primary-border-r___a07h3`,
	"secondaryBorder": `DocumentationItem-module__secondary-border___pYHmg`,
	"secondaryBorderB": `DocumentationItem-module__secondary-border-b___bcXNI`,
	"secondaryBorderT": `DocumentationItem-module__secondary-border-t___Uhwwo`,
	"secondaryBorderL": `DocumentationItem-module__secondary-border-l___kSXe3`,
	"secondaryBorderR": `DocumentationItem-module__secondary-border-r___PFAsE`,
	"gap0": `DocumentationItem-module__gap-0____YLOE`,
	"gap2": `DocumentationItem-module__gap-2___u2XAy`,
	"gap4": `DocumentationItem-module__gap-4___ZKAAz`,
	"gap5": `DocumentationItem-module__gap-5___utauX`,
	"gap6": `DocumentationItem-module__gap-6___ndGDA`,
	"gap8": `DocumentationItem-module__gap-8___Kwk_g`,
	"gap10": `DocumentationItem-module__gap-10___ddp0_`,
	"gap12": `DocumentationItem-module__gap-12___ALKsz`,
	"gap14": `DocumentationItem-module__gap-14___cCgfG`,
	"gap16": `DocumentationItem-module__gap-16___aCTj1`,
	"gap18": `DocumentationItem-module__gap-18___Czizj`,
	"gap20": `DocumentationItem-module__gap-20____sVkZ`,
	"gap24": `DocumentationItem-module__gap-24___OnZVS`,
	"gap26": `DocumentationItem-module__gap-26___eOpN1`,
	"gap30": `DocumentationItem-module__gap-30___q8ow3`,
	"gap32": `DocumentationItem-module__gap-32___UDv8j`,
	"gap40": `DocumentationItem-module__gap-40___EffLm`,
	"gap50": `DocumentationItem-module__gap-50___FNwJI`,
	"flex1": `DocumentationItem-module__flex-1___jnSx9`,
	"flexNone": `DocumentationItem-module__flex-none___uJTdc`,
	"flexColumn": `DocumentationItem-module__flex-column___FHZ3L`,
	"flexRow": `DocumentationItem-module__flex-row___pGDSZ`,
	"verticallyCentered": `DocumentationItem-module__vertically-centered___jlCBH`,
	"horizontallyCentered": `DocumentationItem-module__horizontally-centered___QJZ1P`,
	"horizontallyEnd": `DocumentationItem-module__horizontally-end___RtVz1`,
	"verticallyStart": `DocumentationItem-module__vertically-start___dB7CP`,
	"spaceBetween": `DocumentationItem-module__space-between___xwrvj`,
	"flexWrap": `DocumentationItem-module__flex-wrap___JFJM0`,
	"height100": `DocumentationItem-module__height-100___sq_BK`,
	"width50": `DocumentationItem-module__width-50___Llzbk`,
	"width100": `DocumentationItem-module__width-100___jGCRD`,
	"cursorPointer": `DocumentationItem-module__cursor-pointer___B_Nsl`,
	"cursorNotAllowed": `DocumentationItem-module__cursor-not-allowed___GQhUf`,
	"absoluteCentered": `DocumentationItem-module__absolute-centered___np4YI`,
	"absolute": `DocumentationItem-module__absolute___HXUfL`,
	"relative": `DocumentationItem-module__relative___acYJ1`,
	"fixed": `DocumentationItem-module__fixed___k9ixs`,
	"visible": `DocumentationItem-module__visible___VLn6F`,
	"invisible": `DocumentationItem-module__invisible___Fm0GV`,
	"col90": `DocumentationItem-module__col-90___nYlxn`,
	"colAuto": `DocumentationItem-module__col-auto___L7aIa`,
	"medicalTabs": `DocumentationItem-module__medical-tabs___XRToT`,
	"medicalTableNew": `DocumentationItem-module__medical-table-new___R9uGa`,
	"noPagination": `DocumentationItem-module__no-pagination___SJ8jO`,
	"medicalTableEmpty": `DocumentationItem-module__medical-table-empty___CnW0u`,
	"iconBtn": `DocumentationItem-module__icon-btn___ASI8V`,
	"searchIcon": `DocumentationItem-module__search-icon___zPVNp`,
	"disableSelect": `DocumentationItem-module__disable-select___Is1dH`,
	"breakWord": `DocumentationItem-module__break-word___Yo6JY`,
	"popupClearBtn": `DocumentationItem-module__popup-clear-btn___qFvvS`,
	"scrollMB20": `DocumentationItem-module__scroll-m-b-20___ej8Xe`,
	"container": `DocumentationItem-module__container___UyE8o`,
	"selected": `DocumentationItem-module__selected___F2BDN`,
	"icon": `DocumentationItem-module__icon___rDBdj`,
	"content": `DocumentationItem-module__content___V08xT`,
	"name": `DocumentationItem-module__name___Q6F0r`,
	"type": `DocumentationItem-module__type___NAi5N`,
	"reason": `DocumentationItem-module__reason___IBOKM`,
	"date": `DocumentationItem-module__date___fLUk7`
};
module.exports = ___CSS_LOADER_EXPORT___;
